import React from 'react';
import Forgot from '../../components/ForgotPassword/forgot-password';

export default function ForgotPasswordPage() {
  return <Forgot />;
}
